import { connect } from 'react-redux';
import {
    fetchReviewAccreditation,
    getAccreditationDataFormatted,
    getAccreditationAnswer,
    getCurrentAccreditationId,
    cleanValidatedStatus,
    cleanStartAccreditation,
    loadingAccreditationList,
    setNextAsStartAccreditationForReview,
    getCurrentAccreditationGroupId, loadingManagedOrgs, getManagedOrgsOptions, fetchGetManagedOrgs, clearManagedOrgs
} from '../../../reducers/accreditation/accreditations';
import ReviewAccreditation from './ReviewAccreditation';
import { fetchGetLevels, getLevelsData } from '../../../reducers/common/levels';
import {
    getCurrentContinent,
    setCurrentContinent,
    getCountriesData,
    getContinentsData,
    setCurrentContinentByCountry, getLocationData
} from '../../../reducers/common/location';
import { getTranslation } from "../../../reducers/common/localization";
import {MODAL_REMOVE_ACCREDITATION, showModal} from "../../../reducers/common/activeModal";
import { fetchGetTitleLangs, getOptionalTitleLangsData } from '../../../reducers/common/titleLangs';
import { fetchSubmitForm } from '../../../reducers/common/submitForm';
import { getKey, getKeyLoading } from '../../../reducers/accreditation/certificate';
import {
    fetchGetOrg,
    isAccreditationSigningRequired,
    isOrgBava,
    loadingOrg
} from '../../../reducers/organization/organization';

const mapStateToProps = state => {
    return {
        id: getCurrentAccreditationId(state),
        groupId: getCurrentAccreditationGroupId(state),
        loading: loadingAccreditationList(state),
        data: getAccreditationDataFormatted(state),
        answer: getAccreditationAnswer(state),
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state),
        additionalLangs: getOptionalTitleLangsData(state),
        levels: getLevelsData(state),
        translation: getTranslation(state),
        massageLabelPath: 'review_accreditation.feedback_from_validator_label',        
        signingKey: getKey(state),
        signingKeyLoading: getKeyLoading(state),
        isSigningRequired: isAccreditationSigningRequired(state),
        orgLoading: loadingOrg(state),
        isBava: isOrgBava(state),
        loadingManagedOrgs: loadingManagedOrgs(state),
        managedOrgs: getManagedOrgsOptions(state),
        locationData: getLocationData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSubmit: (id, data) => {
            dispatch(fetchReviewAccreditation(id, data));
        },
        onContinentSet: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        setContinentByCountry: (countryCode) => {
            dispatch(setCurrentContinentByCountry(countryCode));
        },
        onGetAdditionalLangs: () => {
            dispatch(fetchGetTitleLangs());
        },
        onGetLevels: () => {
            dispatch(fetchGetLevels());
        },
        onRemoveAccreditation: () => dispatch(showModal({modalKey: MODAL_REMOVE_ACCREDITATION})),
        onUnmount: () => {
            dispatch(cleanValidatedStatus());
            dispatch(cleanStartAccreditation());
            dispatch(clearManagedOrgs());
        },
        onNext: () => {
            dispatch(setNextAsStartAccreditationForReview());
        },
        onSetSubmitFormLoading: () =>  dispatch(fetchSubmitForm()),
        onGetOrganization: () => {
            dispatch(fetchGetOrg());
        },
        onGetManagedOrgs: (countryCode) => {
            dispatch(fetchGetManagedOrgs(countryCode));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewAccreditation);



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/reviewAccreditation/ReviewAccreditationRejectedByValidator.container.js